"use strict";

var _regeneratorRuntime = require("/codebuild/output/src400645628/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _clientAuth = require("@devsta/client-auth");

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

var ghostUserInvoker = /*#__PURE__*/function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(_ref) {
    var ghostStart, user, history, email, ghostData, _ghostData$data$ghost, token, userData, origCreds, encodedData, base64;

    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            ghostStart = _ref.ghostStart, user = _ref.user, history = _ref.history;
            email = user.email;
            _context.next = 4;
            return ghostStart(email);

          case 4:
            ghostData = _context.sent;
            _ghostData$data$ghost = ghostData.data.ghostStart, token = _ghostData$data$ghost.token, userData = _ghostData$data$ghost.user;
            origCreds = _clientAuth.credentials.get();
            encodedData = {
              token: token,
              user: userData,
              targetURL: '/',
              original: origCreds,
              origURL: '/organisation'
            };
            base64 = btoa(JSON.stringify(encodedData));
            history.rootPush("?ghost=".concat(base64));

          case 10:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function ghostUserInvoker(_x) {
    return _ref2.apply(this, arguments);
  };
}();

var _default = ghostUserInvoker;
exports.default = _default;